var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuitCaseBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13078",
    "data-name": "Group 13078",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.087,
    height: 19.223,
    viewBox: "0 0 23.087 19.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4503",
    "data-name": "Rectangle 4503",
    width: 23.087,
    height: 19.223,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10995",
    "data-name": "Group 10995",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44557",
    "data-name": "Path 44557",
    d: "M0,168.123c.446-.628.761-.132,1.229.053a3.459,3.459,0,0,0,.368.127H9.585v1.463a.521.521,0,0,0,.515.475c.921.089,1.988-.069,2.924-.005a.533.533,0,0,0,.43-.47V168.3h7.987a3.459,3.459,0,0,0,.368-.127c.435-.172.838-.7,1.2-.046l.025,7.166a1.928,1.928,0,0,1-1.726,1.649l-19.666,0A2,2,0,0,1,0,175.369Z",
    transform: "translate(0 -157.722)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44558",
    "data-name": "Path 44558",
    d: "M0,4.505A2.123,2.123,0,0,1,.914,3.192a2.82,2.82,0,0,1,.639-.261H6.7V1.738A2,2,0,0,1,8.435.048c2.043-.148,4.273.1,6.335.014a2.056,2.056,0,0,1,1.564,1.676V2.93h5.152c.746,0,1.494,1.034,1.554,1.731a20.03,20.03,0,0,1-.068,3.58A2.038,2.038,0,0,1,21.4,9.636H13.455c.007-.4.037-.9-.47-.947-.965-.088-2.073.062-3.053.012-.384.139-.353.594-.347.936H1.642A2.1,2.1,0,0,1,.172,8.541L0,8.016ZM14.4,1.94H8.64v.99H14.4Z",
    transform: "translate(0 0)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitCaseBlack);
export default __webpack_public_path__ + "static/media/suitCase_black.d02c45b0ad024cc9314cf6eb803e50bf.svg";
export { ForwardRef as ReactComponent };